import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { IFetchClientResult } from "./types";
import { serverResponse } from "./validators";

export async function fetchClientData(
  userId: string,
): Promise<IFetchClientResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/users/${userId}`,
    {
      headers: {
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
      scope: "sales",
      validator: serverResponse,
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
